import React from 'react'

import { DropdownItem } from '@bikemap/components/Dropdown'
import { gettext } from '@bikemap/js/services'
import { debugState } from './helpers'

/**
 * Item for the user menu of staff users to debug the current state.
 * @param {Object} props
 * @param {() => Object} collectState Function that returns the current state
 */
const DebugStateActionItem = ({ collectState }) => {
    const debugStateText = gettext('Debug state')

    const handleDebugClick = () => {
        debugState(collectState())
    }

    return (
        <DropdownItem icon="i-code">
            <button type="button" onClick={handleDebugClick}>
                {debugStateText}
            </button>
        </DropdownItem>
    )
}

export default DebugStateActionItem
